const STATUS = {
  DRAFT: { key: 'Draf', label: 'Draf' },
  ACTIVE: { key: 'Aktif', label: 'Aktif' },
  EXPIRED: { key: 'Kadaluwarsa', label: 'Kadaluwarsa' },
  INACTIVE: { key: 'Non Aktif', label: 'Non Aktif' },
}

export const wizardItemsDefault = [STATUS.DRAFT, STATUS.ACTIVE, STATUS.EXPIRED]
export const wizardItemsInactive = [STATUS.DRAFT, STATUS.ACTIVE, STATUS.INACTIVE]
export const wizardItemsAddendum = [STATUS.DRAFT, STATUS.ACTIVE]
